import { toast } from "react-toastify";
import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  changeAvatarStart,
  changeAvatarSuccess,
  changeAvatarFailed,
} from "../redux/changeAvatar";
import { closeDialog } from "redux-store/static/redux/dialog";

import { DIALOG } from "helper/enum/dialogEnum";

import { postChangeAvatarApi } from "core/http/service/accountInfo";

function* changeAvatarWork(action: ReturnType<typeof changeAvatarStart>) {
  try {
    const res = yield call(postChangeAvatarApi, {
      file: action.payload,
    });
    yield put({
      type: changeAvatarSuccess.type,
      payload: res,
    });
    yield put({
      type: closeDialog.type,
      payload: { key: DIALOG.CHANGE_AVATAR },
    });

    toast.success("Cập nhật ảnh đại diện thành công");
  } catch (error: any) {
    yield put({
      type: changeAvatarFailed.type,
    });
    toast.error("Thay đổi ảnh đại diện không thành công, vui lòng thử lại");
  }
}

function* watchChangeAvatar() {
  yield takeLatest(changeAvatarStart.type, changeAvatarWork);
}

export default function* ChangeAvatarSaga() {
  yield all([watchChangeAvatar()]);
}
